import { Color } from '~/constants';
import {
    AlertActions,
    useAppDispatch,
} from '~/redux-rtk';
import {
    getDefaultBrowserLanguage,
    getTranslatedText,
} from '~/utils/alertsUtils';

import AlertCard from './AlertCard';
import { useNavigate } from 'react-router-dom';
import { CUSTOM_LAYER_ID } from '~/constants/common';
type Props = {
    evacDetails?: any;
    alertDetails?: any;
};
export const CommonAlertCard = ({ evacDetails, alertDetails }: Props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const handleViewAlertClick = (alertData: any) => {
        dispatch(
            AlertActions.updateSelectedAlertData({
                ...alertData,
                source: 'ALERT',
                navigatedFrom: 'location',
                active: true,
            }),
        );
        navigate(`/alert`);
    };

    const combinedAlerts = [
        ...(evacDetails?.shouldShowEvacData ? evacDetails.evacData
            .filter(alert => alert?.status?.toLowerCase() !== 'normal')
            .map((alert, idx) => ({
            key: idx,
            updatedAt: alert?.updatedAt,
            zoneId: alert?.zoneId,
            status: alert?.status,
            statusReason: alert?.statusReason,
            statusColor: alert?.statusColor,
            customZone: alert?.layerId === CUSTOM_LAYER_ID ? alert?.identifier : "",
            clickOnView: () => navigate(`/zones/${alert?.identifier}`),
        })) : []),
        ...(alertDetails?.shouldShowAlertData ? alertDetails?.data?.content?.map((alert, idx) => ({
            key:alert?.id,
            updatedAt: alert?.updatedAt,
            status: getTranslatedText(alert?.titles, getDefaultBrowserLanguage()),
            statusReason: getTranslatedText(alert?.descriptions, getDefaultBrowserLanguage()),
            statusColor: Color.UniformBlue,
            clickOnView: () => handleViewAlertClick(alert),
        })) : []),
    ];

    const sortedAlerts = combinedAlerts.sort((a, b) => {
        const dateA = new Date(a?.updatedAt).getTime();
        const dateB = new Date(b?.updatedAt).getTime();
        return dateB - dateA;
    });

    return (
        <>
            {sortedAlerts.map(alert => (
                <AlertCard
                    key={alert.key}
                    zoneId={alert.zoneId}
                    status={alert.status}
                    statusReason={alert.statusReason}
                    statusColor={alert.statusColor}
                    clickOnView={alert.clickOnView}
                    customZone={alert?.customZone}
                />
            ))}
        </>
    );
};
